import { useState } from "react";
import { RestTablesView } from "../views/tables/rest-tables-view";

export function Tables({ showKey }) {
    return <RestTablesView title="LAYOUT" subtitle="Designer" showKey={showKey} />
}